import React from 'react';
import {
  formatDate,
  showPrice,
  truncateAmount,
  ONE_DAY_PS_PRODUCT_ID,
} from '../../libs/util';
import { groupInteger } from '../../libs/numberFormat';

const PayoutSummaryTable = ({
  payoutOptions,
  totalPayout,
  selectedCurrency,
  targetCurrency,
  product,
}) => {
  if (!payoutOptions || payoutOptions.length === 0) {
    return null;
  }

  const formatPayoutAmount = (amount) => {
    if (amount === null || amount === undefined) return 0.0;
    const displayCurrency = targetCurrency?.toUpperCase();

    // // Apply truncate ONLY for 1-day PST product
    // if (String(product?.product_id) === String(ONE_DAY_PS_PRODUCT_ID)) {
    //   return truncateAmount(amount, displayCurrency);
    // }
    // // Existing behaviour for all others
    // return showPrice(amount, displayCurrency, null, true);
    return groupInteger(truncateAmount(amount, displayCurrency));
  };
  return (
    <div className="nk-block mt-2">
      <div className="card card-bordered">
        <div className="card-inner py-3">
          <h6 className="card-title mb-2">Payout Schedule</h6>
          <div className="payout-section compact">
            {payoutOptions.map((option, index) => (
              <div className="payout-row py-1" key={index}>
                <div className="payout-label">
                  {option.isMaturity ? 'Last Payout:' : `Payout ${index + 1}:`}
                </div>
                <div className="payout-content">
                  <div className="form-control-wrap justify-center">
                    <span className="payout-date fs-13px">
                      {formatDate(option.date)}
                    </span>
                  </div>
                  <div className="payout-value text-info">
                    {
                      /* showPrice(
                      option.payout_amount || option.total,
                      targetCurrency,
                      null,
                      true
                    )*/
                      formatPayoutAmount(option.payout_amount || option.total)
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayoutSummaryTable;
